import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from '@/store/index'
import vuetify from '@/plugins/vuetify'
import i18n from '@/plugins/i18n'
import '@/plugins/vee-validate'
import '@/plugins/vue-mask'
import '@/plugins/moment'
import '@/plugins/cookies'
import '@/plugins/vue-google-charts'
import mixinGlobalControl from "@/mixins/mixinGlobalControl";
import UnitOfWorkService from "@/services/UnitOfWorkService";

import {
  abilitiesPlugin
} from '@casl/vue'
import ability from '@/plugins/abilityPlugIn'
import defineAbilitiesFor from '@/plugins/ability'

ability.update(defineAbilitiesFor(''))
Vue.use(abilitiesPlugin, ability)



Vue.config.productionTip = false

Vue.mixin(mixinGlobalControl)

Vue.prototype.services = new UnitOfWorkService()


new Vue({
  i18n,
  vuetify,
  router,
  store,
  render: h => h(App)
}).$mount('#app')